import { render, staticRenderFns } from "./CreateGroupSurveyLaunch.vue?vue&type=template&id=38c50775&scoped=true"
import script from "./CreateGroupSurveyLaunch.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurveyLaunch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c50775",
  null
  
)

export default component.exports